import { render, staticRenderFns } from "./pendenciesModal.vue?vue&type=template&id=42b7d325&scoped=true"
import script from "./pendenciesModal.vue?vue&type=script&lang=js"
export * from "./pendenciesModal.vue?vue&type=script&lang=js"
import style0 from "./pendenciesModal.vue?vue&type=style&index=0&id=42b7d325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7d325",
  null
  
)

export default component.exports